module.exports = __webpack_public_path__ + "img/seguro-portateis.685259a1.svg";